export default function Review() {
  return (
    <>
      <h2>Review</h2>
      <p>
        rem blanditiis laudantium ab nobis ullam esse laboriosam mollitia. Lorem ipsum dolor sit
        amet consectetur adipisicing elit. Ab eum odio quod fuga itaque ducimus architecto delectus
        modi porro adipisci. Corporis rem blanditiis laudantium ab nobis ullam esse laboriosam
        mollitia.
      </p>
    </>
  );
}
